import { useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid";
import { lighten } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";

const CustomizedComponent = styled(Grid)(({ theme }) => ({
  position: "relative",
  paddingBottom: 0,
  // paddingBottom: theme.spacing(1),
  overflowY: "auto",
  marginTop: "64px", //height of the portalAppBar
  "&::-webkit-scrollbar": {
    width: theme.spacing(2),
  },
  "&:hover::-webkit-scrollbar": {
    width: theme.spacing(2),
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: theme.palette.commonground,
    backgroundClip: "content-box",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  "&::-webkit-scrollbar-thumb": {
    opacity: "0.5",
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  "&:hover::-webkit-scrollbar-thumb": {
    backgroundColor: lighten(theme.palette.secondary.main, 0.2),
  },
}));

const PortalGridContent = props => {
  const { children, hasPortalAppBar = true, ...other } = props;

  const theme = useTheme();
  const mobileLayout = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <CustomizedComponent
      container
      padding={mobileLayout ? "2px" : theme.spacing(1)}
      marginTop={hasPortalAppBar ? "64px" : theme.spacing(1)} //height of the portalAppBar
      spacing={mobileLayout ? 0 : 2}
      {...other}
    >
      {children}
    </CustomizedComponent>
  );
};

export default PortalGridContent;
